export const allowedImageTypes = ['.jpeg', '.jpg', '.png']
export const allowedVideoTypes = ['.mp4', '.mpg', '.mov']
export const allowedDocumentTypes = ['.pdf']
export const allowedAudioTypes = ['.mp3', '.wav', '.aac']
